export const ARTIST_TATTOO_CONTENT = {
    artistTattooTitle: '“Từng nét mực, từng câu chuyện cuộc đời”',
    artistTattooText: '“Chúng tôi tạo ra những hình xăm không chỉ là tác phẩm nghệ thuật mà là từng đường kim khắc sâu câu chuyện đầy ý nghĩa, ghi dấu những khoảnh khắc đậm chất sống. Với đam mê cháy bỏng và tay nghề đỉnh cao, chúng tôi mang đến trải nghiệm không thể nào quên!”',
    artistTattooText2: '-- Artist Thế Trung © “𝘁𝗵𝗲 𝗧𝗵𝗲 𝗧𝗿𝘂𝗻𝗴 𝗧𝗮𝘁𝘁𝗼𝗼 𝗦𝘁𝘂𝗱𝗶𝗼” --',
    artistTattooName: '-- Artist Thế Trung --',
}